import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'behaviourPlanSearchPipe', pure: false,
    standalone: false
})
export class BehaviourPlanSearch implements PipeTransform {
  transform(value, args?): Array<any> {
    let searchText = new RegExp(args, 'ig');
    if (value) {
      return value.filter(plan => {
        if (plan.name) {
          return plan.name.search(searchText) !== -1;
        }
      });
    }
  }
}
